<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Fatura - {{fatura.faturaId}} - {{verificaFaturaStatus(fatura.faturaStatus)}}</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
        <mat-icon>fullscreen</mat-icon>
      </button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
<div mat-dialog-actions class="text-right floating">
  <button mat-raised-button (click)="imprimir()" *ngIf="fatura.faturaId > 0" matTooltip="Imprimir">
    <mat-icon>print</mat-icon>
  </button>
  <button mat-raised-button [matMenuTriggerFor]="opcoes" matTooltip="Opções" *ngIf="fatura.faturaId > 0 && fatura.faturaStatus != 100" >
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #opcoes>
    <button *ngIf="permiteFaturamento &&
      !fatura.nfseId &&
      this.tpFatura == 0 &&
      fatura.faturaTipoDocumento == 1 &&
      faturaNfsesAndContaDto?.nfseIds?.length == 0 &&
      faturaNfsesAndContaDto?.contaParcelaIds?.length == 0 &&
      faturaCadastroForm.value.documentoFiscal != 2 && 
      faturaCadastroForm.get('faturaStatus')?.value != 99"
      (click)="gerarNfseContaComValidacao()" mat-menu-item [disabled]="!validarSomaParcelasIgualValorLiquido()">
      Gerar {{textoContaView}}, Cobrança e NFS-e
    </button>
    <button *ngIf="permiteFaturamento &&
      !fatura.nfeId &&
      this.tpFatura == 0 &&
      fatura.faturaTipoDocumento == 0 &&
      faturaCadastroForm.value.documentoFiscal != 2 &&
      faturaCadastroForm.get('faturaStatus')?.value != 99"
      (click)="gerarNfeConta()" mat-menu-item [disabled]="!validarSomaParcelasIgualValorLiquido()">
      Gerar {{textoContaView}}, Cobrança e NF-e
    </button>
    <button *ngIf="permiteFaturamento  &&
      faturaNfsesAndContaDto?.contaParcelaIds?.length == 0  &&
      this.tpFatura == 0 &&
      faturaCadastroForm.get('faturaStatus')?.value != 99"
      (click)="gerarContaEBoleto(false, true)" mat-menu-item [disabled]="!validarSomaParcelasIgualValorLiquido()">
      Gerar {{textoContaView}} e Cobrança
    </button>
    <button *ngIf="permiteFaturamento  &&
      faturaNfsesAndContaDto?.contaParcelaIds?.length == 0 &&
      faturaCadastroForm.get('faturaStatus')?.value != 99"
      (click)="gerarConta(true)" mat-menu-item [disabled]="!validarSomaParcelasIgualValorLiquido()">
      Gerar {{textoContaView}}
    </button>
    <button *ngIf="!fatura.nfseId &&
      this.tpFatura == 0 &&
      faturaNfsesAndContaDto?.nfseIds.length == 0 &&
      faturaCadastroForm.value.documentoFiscal != 2 &&
      faturaCadastroForm.get('faturaStatus')?.value != 99"
      (click)="gerarSomenteNfseComValidacao()" mat-menu-item [disabled]="!validarSomaParcelasIgualValorLiquido()">
      Gerar Somente NFS-e
    </button>
    <button *ngIf="fatura.faturaId > 0 &&
      tpFatura == 0  && 
      faturaCadastroForm.get('faturaStatus')?.value != 99"
      (click)="EnviaEmail(faturaCadastroForm)" mat-menu-item [disabled]="!validarSomaParcelasIgualValorLiquido()">
      Enviar Fatura por E-mail</button>
    <button *ngIf="fatura.faturaId > 0 && fatura.faturaStatus != 99" (click)="cancelarFatura(fatura.faturaId)"
      mat-menu-item>Cancelar
    </button>
    <button mat-menu-item [matMenuTriggerFor]="nfseMenu" *ngIf="faturaNfsesAndContaDto?.nfseIds.length > 0">NFSEs</button>
    <mat-menu #nfseMenu="matMenu">
      <button *ngFor="let nfseId of faturaNfsesAndContaDto?.nfseIds" (click)="visualizarNfse(nfseId)" mat-menu-item>
        NFS-e - {{ nfseId }}
      </button>
    </mat-menu>
    <button *ngIf="fatura.contaId > 0 && faturaNfsesAndContaDto?.contaIds.length == 0" (click)="abreModalConta(fatura.faturaTipo, fatura.contaId, fatura.faturaTipo)"
      mat-menu-item>
      <mat-icon>edit</mat-icon> Conta
    </button>
    <button mat-menu-item [matMenuTriggerFor]="contaMenu" *ngIf="faturaNfsesAndContaDto?.contaIds?.length > 0">Contas</button>
    <mat-menu #contaMenu="matMenu">
      <button *ngFor="let contaId of faturaNfsesAndContaDto?.contaIds" (click)="abreModalConta(
        faturaCadastroForm.value.faturaTipo, contaId, faturaCadastroForm.value.faturaTipo)" mat-menu-item>
        Conta - {{ contaId }}
      </button>
    </mat-menu>
    <button *ngIf="Logs.length > 0" (click)="log(fatura.faturaId)"
      mat-menu-item>LOG da Fatura
    </button>
  </mat-menu>
  <button mat-raised-button color="primary" matTooltip="Salvar" (click)="salvar(faturaCadastroForm)"
    [disabled]="!faturaCadastroForm.valid || fatura.faturaStatus == 99 || fatura.faturaStatus == 1 || fatura.faturaStatus == 100 || !validarSomaParcelasIgualValorLiquido() || !validarQuantidadesItens()">
    <mat-icon>save</mat-icon>&ensp;Salvar Fatura
  </button>
  <div class="error-container" style="margin-top: 8px; text-align: left;">
    <div *ngIf="!validarSomaParcelasIgualValorLiquido()" class="error-message" style="color: red; margin-bottom: 4px;">
      * Parcelas: A soma das parcelas não está batendo com o valor total
    </div>
    <div *ngIf="!validarQuantidadesItens()" class="error-message" style="color: red;">
      * Itens: A quantidade de itens deve ser maior que zero.
    </div>
  </div>
</div>
<mat-dialog-content>
  <div class="md-dialog-content floating">
    <div class="row">
      <form [formGroup]="faturaCadastroForm">
        <div class="col-md-12">
          <br>
          <div class="row">
            <div class="col-md-12 form-group">
              <h3>Dados Gerais da Fatura</h3>
            </div>
            <br>
            <mat-form-field class="col-md-12 col-xs-12 form-group">
              <mat-label>Descrição</mat-label>
              <input type="text" matInput formControlName="descricao" required>
            </mat-form-field>
          </div>
          <div class="row">
            <mat-form-field class="col-md-6 col-xs-12 form-group">
              <mat-label>Emitente</mat-label>
              <mat-select formControlName="empresaId" aria-required="true" [required]="true" required>
                <mat-option *ngFor="let empresa of empresas" [value]="empresa.empresaId"
                  (blur)="selecionaCadastroFinanceiroEmpresa(empresa)">
                  {{empresa.cnpj}} - {{empresa.nomeFantasia}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-md-6 col-xs-12 form-group">
              <mat-label>Parceiro</mat-label>
              <input type="text" matInput [matAutocomplete]="auto" formControlName="parceiroAutoComplete" required>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let parceiro of parceiros" [value]="parceiro.nomeFantasia"
                  (click)="DeterminaParceiro(parceiro)" required>
                  CNPJ/CPF: {{parceiro.cnpj == null || parceiro.cnpj == undefined || parceiro.cnpj == '' ?
                  parceiro.cpf : parceiro.cnpj}} - {{parceiro.razaoSocial}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

          </div>
          <div class="row " *ngIf="IFatura.faturaTipoDocumento == 1">
            <mat-form-field class="col-md-6 col-xs-12 form-group">
              <mat-label>Mês de Referência</mat-label>
              <input matInput [matDatepicker]="dp" placeholder="Month and Year" formControlName="mesAnoReferencia">
               <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
              <mat-datepicker #dp
                              startView="multi-year"
                              (yearSelected)="chosenYearHandler($event)"
                              (monthSelected)="chosenMonthHandler($event, dp)"
                              panelClass="example-month-picker">
              </mat-datepicker>
            </mat-form-field>
            <mat-form-field class="col-md-6 col-xs-12 form-group" *ngIf="integracaoSOC && this.tpFatura == 0">
              <mat-label>Status Integração com o SOC</mat-label>
              <mat-select formControlName="statusIntegracaoSOC">
                <mat-option [value]="0">Desligada</mat-option>
                <mat-option [value]="1">Ligada</mat-option>
                <mat-option [value]="2">Processada</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <br />
          <div class="row">
            <div class="col-md-12 form-group">
              <hr>
              <h3>Itens da Fatura</h3>
            </div>
            <div class="col-md-12">
              <app-itens [getProdutoPorNomeEEmpresasService]="getProdutoPorNomeEEmpresasService.bind(this)"
                [empresas]="faturaEmpresas" [itens]="fatura.faturaItens ? fatura.faturaItens : []"
                (novosItens)="onItensChange($event)" [panelOpenState]="true"
                [permitirItemSemId]="IFatura?.faturaTipo==1 && IFatura?.faturaTipoDocumento==3 ?true:false"
                [tipoItem]="IFatura?.faturaTipo==1?1:0"
                [permitirSubitens]="true"
                (valorTotalBruto)="onValorTotalBrutoChange($event)"
                (valorTotalLiquido)="onValorTotalLiquidoChange($event)"></app-itens>
            </div>
          </div>
          <br>
          <hr>
          <div class="row " *ngIf="IFatura.faturaTipoDocumento == 1">
            <div class="col-md-12 form-group">
              <h3>Dados Fiscais</h3>
            </div>
            <mat-form-field class="col-md-6 col-xs-12 form-group">
              <mat-label>Documento Fiscal:</mat-label>
              <mat-select formControlName="documentoFiscal">
                <mat-option [value]="1">Nfse</mat-option>
                <mat-option [value]="2">Recibo</mat-option>
              </mat-select>
            </mat-form-field>
               <mat-form-field class="col-md-6 col-xs-12 form-group">
              <mat-label>Serviço/Atividade:</mat-label>
               <mat-select formControlName="servicoListaId">
               <mat-option value="-1">Utilizar as pré-configuradas nos itens (recomendado)</mat-option>
              <mat-option *ngFor="let servicoLista of servicosLista" [value]="servicoLista.servicoListaId">
                {{servicoLista.codigo}} - {{servicoLista.descricao}}
              </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
            <br>
          <hr>
          <div class="row">
            <div class="col-md-12 form-group">
              <h3>Dados Financeiros</h3>
            </div>
            <div class="col-md-12 col-xs-12 form-group">
              <mat-checkbox formControlName="faturarParaOutraEmpresa">
                Faturar financeiro para outra empresa
              </mat-checkbox>
            </div>
            <mat-form-field class="col-md-6 col-xs-12 form-group" *ngIf="faturaCadastroForm.get('faturarParaOutraEmpresa').value">
              <mat-label>Empresa para Faturamento</mat-label>
              <mat-select formControlName="empresaFinanceiroId">
                <mat-option [value]="null">Selecione uma empresa</mat-option>
                <mat-option *ngFor="let empresa of empresas" [value]="empresa.empresaId">
                  {{empresa.cnpj}} - {{empresa.nomeFantasia}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-md-4 col-xs-12 form-group">
              <mat-label>Categoria de {{textoContaView}}</mat-label>
              <mat-select formControlName="grupoContaId">
                <mat-option *ngFor="let grupoConta of grupoContas" [value]="grupoConta.grupoContaId">
                  {{grupoConta.descricao}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-md-4 col-xs-12 form-group">
              <mat-label>Caixa (Fluxo de Caixa)</mat-label>
              <mat-select formControlName="caixaId">
                <mat-option *ngFor="let caixa of caixas" [value]="caixa.caixaId">
                  {{caixa.nome}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="col-md-4 col-xs-12 form-group">
              <mat-label>Centro de Custo</mat-label>
              <mat-select formControlName="centroCustoId">
                <mat-option *ngFor="let centroCusto of centroCustos" [value]="centroCusto.centroCustoId">
                  {{centroCusto.descricao}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="row">
            <div class="col-md-12 col-mx-12 form-group" *ngIf="faturaCadastroForm.value">
              <app-calcula-parcelas fixed [valorTotal]="faturaCadastroForm.get('valorLiquido').value"
                [parcelaIdNome]="'faturaParcelaId'" [panelOpenState]="true"
                [parcelasIniciais]="faturaParcelas ? faturaParcelas : []"
                (parcelasFinaisChange)="onParcelasFinaisChange($event)">
              </app-calcula-parcelas>
            </div>
          </div>

        </div>
      </form>
    </div>

  </div>

</mat-dialog-content>
